export const getLocaleFromUrl = () => {
  const match = window.location.pathname.match(/\/([a-z]{2})(?=\/|$)/i);
  return match ? match[1] : null; // Extracts 'de', 'en', etc.
};
